module.exports = __webpack_public_path__ + "assets/discount-coupon-741a97.svg";